import { Chip, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomNewButton from "../../../newComponent/themeprovider/button/CustomNewButton";
import CustomPopup from "../../../../components/CustomPopup";
import CreateAssignmentForm from "../AddAssignment";
import { DataGrid } from "@mui/x-data-grid";
import CustomNoRowsOverlay from "../../../newComponent/TableCustomeComp/CustomNoRowsOverlay";
import { ThemeProvider } from "@emotion/react";
import mainTheme from "../../../newComponent/themeprovider/mainTheme/MainTheme";
import MainCard from "../../../../components/Maincard";
import SendAssignmentsForm from "../SendAssignmentsForm";
import HeadingCard from "../../../newComponent/NewCardsComp/HeadingCard";
import { getAssignmentSubmissions } from "../services";
import CustomSnackbar from "../../../components/ui-component/snackbar/CustomSnackbar";
import { fDate } from "../../../../utils/formatTime";
import EditIconcomp from "../../../newComponent/iconsComp/EditIconcomp";
import DenyIcon from "../../../newComponent/iconsComp/DenyIcon";
import LoaderComp from "../../../newComponent/LoaderComp/Loader";
import GradeAssignment from "./EditAssignMentSubmission";
import RejectAssignment from "./DeclinedAssignment";
import VeiwIcon from "../../../newComponent/iconsComp/VeiwIcon";
import ViewSelectedAssignmentDetails from "./ViewSelectedAssignmentDetails";

export default function ViewAssignMentDetails() {
  const userId = localStorage.getItem("userId");
  const userRole = localStorage.getItem("userRole");
  const [openAddForm, setOpenAddForm] = React.useState(false);
  const [assignmentsDetails, setAssignmentsDetails] = React.useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [openEditForm, setOpenEditForm] = React.useState(false);
  const [rowData, setRowData] = React.useState({});
  const [openDeleleteForm, setOpenDeleleteForm] = React.useState(false);
  const [openViewPoupup, setOpenViewPoupup] = useState(false);

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleOpen = () => setOpenAddForm(true);
  const handleClose = () => setOpenAddForm(false);

  const handleEditOpen = (rowData) => {
    setOpenEditForm(true);
    setRowData(rowData);
  };

  const handleEditClose = () => setOpenEditForm(false);

  const handleOpenDelete = (rowData) => {
    setOpenDeleleteForm(true);
    setRowData(rowData);
  };

  const handleDeleteClose = () => setOpenDeleleteForm(false);

  const handleOpenView = (rowData) => {
    setOpenViewPoupup(true);
    setRowData(rowData);
  };

  const handleCloseView = () => setOpenViewPoupup(false);
  const columns = [
    {
      field: "action",
      headerName: "Action",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <div style={{ display: "flex", gap: "10px" }}>
          {params.row?.status === "Submitted" && userRole==="trainer"  &&(
            <>
              <EditIconcomp
                onClick={() => handleEditOpen(params.row)}
                tooltipTitle="Edit"
                fontSize="0.9rem"
              />
              <DenyIcon
                fontSize="0.9rem"
                tooltipTitle="Decline"
                onClick={() => handleOpenDelete(params.row)}
              />
            
            </>
          )}


            <VeiwIcon
                fontSize="0.9rem"
                onClick={() => handleOpenView(params.row)}
                tooltipTitle="View"
              />
             
        </div>
      ),
    },

    {
      field: "student_name",
      headerName: " Name",
      width: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <Typography>
          {params.row?.sp_user_id?.first_name}{" "}
          {params.row?.sp_user_id?.last_name}
        </Typography>
      ),
    },
    {
      field: "student_email",
      headerName: " Email",
      width: 200,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <Typography>{params.row?.sp_user_id?.email} </Typography>
      ),
    },
    {
      field: "student_mobile",
      headerName: " Mobile",
      width: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <Typography>{params.row?.sp_user_id?.mobile} </Typography>
      ),
    },
    {
      field: "asiignment_name",
      headerName: "Assignment Name",
      width: 200,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <Typography>{params.row?.assignment_id?.title}</Typography>
      ), // params.row?.assignment_id?.title,
    },
    {
      field: "assignment_type",
      headerName: "Assignment Type",
      width: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <Typography>{params.row?.assignment_id?.assignment_type}</Typography>
      ), // params.row?.assignment_id?.assignment_type,
    },
    {
      field: "status",
      headerName: "Status",
      width: 130,
      align: "center",
      headerAlign: "center",
     renderCell: (params) => {
  return params?.row?.status === "Pending" ? (
    <Chip size="small" variant="contained" label={params?.row?.status} color="warning" />
  ) : params?.row?.status === "Graded" ? (
    <Chip size="small" variant="contained"  label={params?.row?.status} color="secondary" />
  ) : params?.row?.status === "Rejected" ? (
    <Chip size="small" variant="contained" label={params?.row?.status} color="error" />
  ) : (
    <Chip size="small" variant="contained" label={params?.row?.status} color="primary" />
  );
}

    },
    {
      field: "submitted_date",
      headerName: "Submitted Date",
      width: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <Typography>{fDate(params.row?.submitted_date)}</Typography>
      ), // fDate(params.row.submitted_date),
    },
    {
      field: "marks-obtained",
      headerName: "Marks Obtained",
      width: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <Typography>{params.row?.obtained_marks}</Typography>
      )
    },
    {
      field: "checked_date",
      headerName: "Checked Date",
      width: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <Typography>{fDate(params.row?.checked_date)}</Typography>
      )
    },
    {
      field: "checked_by",
      headerName: "Checked By",
      width: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <Typography>
          {params.row?.checked_by?.first_name} {params.row?.checked_by?.last_name}
        </Typography>
      )
    },
  ];

  const handleFetchData = async () => {
    const requestData = {
      user_id: parseInt(userId),
      // request_for: criteria,
    };
    setIsLoading(true);
    try {
      const responseData = await getAssignmentSubmissions(requestData);

      if (responseData.status === 200) {
        setAssignmentsDetails(responseData.data);
        setIsLoading(false);
       
      } else {
        setAssignmentsDetails([]);
        showSnackbar(responseData.message, "error");
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      showSnackbar(error.message, "error");
      setIsLoading(false);
    }
  };

  useEffect(() => {
    handleFetchData();
  }, [userId]);

  return (
    <>
      <LoaderComp isLoading={isLoading} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <HeadingCard label="Assignment Submission Details" />
        </Grid>

        {/* <Grid item xs={12} sm={6} md={8} textAlign="right">
          <CustomNewButton
            label="Send Assignment"
            onClick={handleOpen}
            disabled={false}
          />
        </Grid> */}
        <Grid item xs={12}>
          <MainCard>
            {" "}
            <DataGrid
              rows={assignmentsDetails}
              columns={columns}
              slots={{
                noRowsOverlay: CustomNoRowsOverlay,
              }}
              autoHeight
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 25,
                  },
                },
              }}
              pageSizeOptions={[25, 50, 100]}
            />
          </MainCard>
        </Grid>
      </Grid>
      <CustomPopup
        open={openAddForm}
        onClose={handleClose}
        maxWidth="md"
        //title='My Task Report'
        component={<SendAssignmentsForm onClose={handleClose} />}
      />

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />

      <CustomPopup
        open={openEditForm}
        onClose={handleEditClose}
        maxWidth="sm"
        title="Grade Assignment"
        showDivider
        component={
          <GradeAssignment rowData={rowData} onClose={handleEditClose} />
        }
      />

      <CustomPopup
        open={openDeleleteForm}
        onClose={handleDeleteClose}
        maxWidth="sm"
        title="Decline Assignment"
        showDivider
        component={
          <RejectAssignment rowData={rowData} onClose={handleDeleteClose} />
        }
      />

      <CustomPopup
        open={openViewPoupup}
        onClose={handleCloseView}
        maxWidth="sm"
        title="View Assignment"
        showDivider
        component={
          <ViewSelectedAssignmentDetails
            rowData={rowData}
            onClose={handleCloseView}
          />
        }
      />
    </>
  );
}
